import { render } from "./RGPDPopin.vue?vue&type=template&id=7cf53efc&scoped=true"
import script from "./RGPDPopin.vue?vue&type=script&lang=ts"
export * from "./RGPDPopin.vue?vue&type=script&lang=ts"

import "./RGPDPopin.vue?vue&type=style&index=0&id=7cf53efc&scoped=true&lang=css"
import "./RGPDPopin.vue?vue&type=style&index=1&id=7cf53efc&lang=css"
script.render = render
script.__scopeId = "data-v-7cf53efc"

export default script